import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Button } from '@mssgme/ui';
import { useQRCode } from './hooks';
import styles from './ShareQR.scss';

export default function ShareQR({ url }) {
    const { t } = useTranslation('cards');
    const base64Url = useQRCode(url, { width: 1000 });

    return (
        <div>
            <p className={styles.headingInstruction}>{t('pageShare.qr_info')}</p>
            <div className={styles.qrImage}>
                <img src={base64Url} />
                <Button tag="a" href={base64Url} download="my_mssgme_qr.png">
                    {t('pageShare.qr_download')}
                </Button>
            </div>
        </div>
    );
}

ShareQR.propTypes = {
    url: PropTypes.string.isRequired,
};
